import ExpandCircleDownOutlined from '@mui/icons-material/ExpandCircleDownOutlined';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';

import { SmallButton } from '~components/Order/ordersDispatchStyledComponents';
import { NEW_DISPATCH_TOPBAR_CONTROLS_HEIGHT_IN_PX } from '~constants/filters';
import useIsCompanySuspended from '~hooks/useIsCompanySuspended/useIsCompanySuspended';

interface CreateOrderButtonProps {
  isForResumeOrderCreation?: boolean;
  onClick: () => void;
  disabled?: boolean;
}

function CreateOrderButton({
  isForResumeOrderCreation,
  onClick,
  disabled = false,
}: CreateOrderButtonProps) {
  const theme = useTheme();
  const isCompanySuspended = useIsCompanySuspended();
  const isDisabled = disabled || isCompanySuspended;

  return (
    <Tooltip
      title={isCompanySuspended ? t('billing.contact_billing_to_enable_access') : ''}
    >
      <span>
        <Box>
          {isForResumeOrderCreation ? (
            <SmallButton
              color="brandV2OrangeDark"
              onClick={onClick}
              disabled={isDisabled}
              startIcon={<ExpandCircleDownOutlined />}
              variant="text"
              sx={{
                '&.MuiButtonBase-root': {
                  height: `${NEW_DISPATCH_TOPBAR_CONTROLS_HEIGHT_IN_PX}px`,
                  mr: -1,
                  pl: 0.5,
                  pr: 1,
                  py: 0,
                  '&:hover': { borderColor: theme.brandV2.colors.treadOrange },
                  '.MuiButton-startIcon': { ml: 0, mr: 0.5 },
                  '.MuiSvgIcon-root': { fontSize: '24px', transform: 'rotate(90deg)' },
                },
              }}
            >
              {t('dispatch.dispatch_v2.resume_new_order')}
            </SmallButton>
          ) : (
            <SmallButton
              color="brandV2Yellow"
              onClick={onClick}
              disabled={isDisabled}
              sx={{
                '&.MuiButtonBase-root': {
                  height: `${NEW_DISPATCH_TOPBAR_CONTROLS_HEIGHT_IN_PX}px`,
                },
              }}
            >
              {t('dispatch.dispatch_v2.new_order')}
            </SmallButton>
          )}
        </Box>
      </span>
    </Tooltip>
  );
}

export default observer(CreateOrderButton);
